<template>
  <div class="mt-2">
    <CRow class="gx-2" style="min-height: 70px">
      <CCol sm="3" style="height: 40px" class="pt-2">
        <label class="text-gray-600 font-20">{{ item.value }} </label>
      </CCol>
      <CCol sm="5">
        <v-date-picker
          v-if="item.dataType.value == 'DATETIME' || item.dataType.value == 'DATE'"
          v-model="item.fieldValue"
          color="purple"
          :popover="{
            visibility: !edit ? 'hidden' : 'hover-focus',
          }"
          :masks="{
            input: dateInputFormat,
          }"
        >
          <template v-slot="{ inputValue, inputEvents }" tag="div" class="d-block">
            <input
              :readonly="!edit"
              :value="inputValue"
              v-on="inputEvents"
              class="text-gray-700 form-control text-gray-700 font-20 detail-field-input"
              :class="!edit ? 'bg-gray-100' : 'bg-white'"
              @keypress="isNumber($event)"
              @mouseenter="() => (detailShow = true)"
              @mouseleave="() => (detailShow = false)"
            />
          </template>
        </v-date-picker>
        <CInput
          v-else
          :key="item.fieldName"
          :type="inputType(item.dataType.value)"
          v-model="$v.item.fieldValue.$model"
          :isValid="checkIfValid(item.dataType.value)"
          @keypress="isNumber($event)"
          :readonly="!edit"
          :invalidFeedback="invalidFeedback(item.dataType.value)"
          :placeholder="$t('audience.detail.contactInformation.placeholder')"
          @mouseenter="() => (detailShow = true)"
          @mouseleave="() => (detailShow = false)"
          class="detail-field-input"
          :class="!edit ? 'bg-gray-100' : 'bg-white'"
        />
      </CCol>
      <CCol sm="2" class="px-0 pb-3">
        <p v-show="detailShow" class="m-0 text-lowercase text-center text-gray-700 bg-gray-200 h-100 px-2 pt-1">
          {{ $t('audience.detail.contactInformation.field.desc', [item.dataType.value]) }}
        </p>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { numeric, email, minLength } from 'vuelidate/lib/validators'
import { getUserDateFormat } from '@/utils/dateUtil.js'

export default {
  name: 'inputContactInfo',
  props: {
    item: {
      type: Object,
      require: true,
    },
    edit: {
      type: Boolean,
      require: true,
    },
  },

  mounted() {
    const userDateFormat = this.$store.state.auth.user.dateTimeFormat
    this.dateInputFormat = getUserDateFormat(userDateFormat).toUpperCase()
  },

  data() {
    return {
      type: this.item.dataType.value,
      detailShow: false,
      dateInputFormat: 'DD/MM/YYYY',
      masks: {
        input: 'DD-MM-YYYY',
      },
    }
  },

  computed: {
    // date: {
    //   get() {
    //     if (this.item.format && this.item.fieldValue) {
    //       return this.fieldValueHandler(this.item.fieldValue, this.item.format).toJSDate()
    //     }
    //     return this.item.fieldValue || ''
    //   },
    //   set(newValue) {
    //     console.log('newValue', newValue, DateTime.fromString(newValue, this.item.format))
    //     this.item.fieldValue = DateTime.fromString(newValue, this.item.format)
    //     // this.item.fieldValue = DateTime.fromString(newValue, this.item.format).toLocaleString()
    //   },
    // },
  },

  mixins: [validationMixin],

  validations() {
    if (this.type && this.type == 'NUMBER') {
      return {
        item: {
          fieldValue: {
            numeric,
          },
        },
      }
    }
    if (this.type && this.type == 'MSISDN') {
      return {
        item: {
          fieldValue: {
            minLength: minLength(0),
          },
        },
      }
    }

    if (this.type && this.type == 'DATE') {
      return {
        item: {
          fieldValue: {
            minLength: minLength(2),
          },
        },
      }
    }

    if (this.type && this.type == 'EMAIL') {
      return {
        item: {
          fieldValue: {
            email,
          },
        },
      }
    }

    if (this.type && this.type == 'STRING') {
      return {
        item: {
          fieldValue: {
            minLength: minLength(0),
          },
        },
      }
    }

    if (this.type && this.type == 'DATETIME') {
      return {
        item: {
          fieldValue: {
            minLength: minLength(2),
          },
        },
      }
    }
  },

  methods: {
    checkIfValid() {
      const field = this.$v.item.fieldValue
      if (!field.$dirty) {
        return null
      }
      this.$emit('isvalid', !(field.$invalid || null))
      return !(field.$invalid || null)
    },

    isNumber: function (evt) {
      if (this.item.dataType.value == 'DATETIME' || this.item.dataType.value == 'DATE') {
        evt.preventDefault()
      }

      if (this.item.dataType.value == 'NUMBER' || this.item.dataType.value == 'MSISDN') {
        evt = evt ? evt : window.event
        let charCode = evt.which ? evt.which : evt.keyCode
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      }
    },

    invalidFeedback(value) {
      const feedback = {
        NUMBER: 'The field must be numeric',
        STRING: 'Minimum number of characters 4',
        DATETIME: 'The field must be datatime',
        DATE: 'The field must be date',
        BOOLEAN: 'The field must be boolean',
        EMAIL: 'The field must be email',
      }

      return feedback[value] || 'feedback'
    },

    inputType(value) {
      const feedback = {
        NUMBER: 'number',
        STRING: 'text',
        MSISDN: 'text',
        DATETIME: 'date',
        DATE: 'date',
        BOOLEAN: 'checkbox',
        EMAIL: 'email',
      }

      try {
        return feedback[value] || 'feedback'
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-field-input {
  min-height: 50px;
  border: $gray-200 solid 1px !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.wrapper-prepend {
  .form-group span,
  .form-control {
    ~ .vdate-picker_typeDate,
    ~ .input-group-append {
      opacity: 0;
    }

    &:focus,
    &:hover {
      ~ .input-group-append,
      ~ .vdate-picker_typeDate {
        opacity: 1;
      }
    }
  }
}
</style>
<style lang="scss">
/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.wrapper-prepend {
  span,
  .form-control {
    ~ .vdate-picker_typeDate,
    ~ .input-group-append {
      opacity: 0;
    }

    &:focus,
    &:hover {
      ~ .input-group-append,
      ~ .vdate-picker_typeDate {
        opacity: 1;
      }
    }
  }
}
</style>
